<ng-template pTemplate="header">
  <div class="btn-custom">
    1. {{ isDownload ? 'Permissão para download' : 'Estoque para grupos' }}
  </div>
</ng-template>
<div class="col-12 md:col-12" *ngIf="!isDownload">
  <div class="flex flex-column gap-2">
    <label for="print-batch-quantity mb-2">Quantidade destinada para grupos:</label>
    <p-inputNumber
      inputId="print-batch-quantity"
      [showButtons]="true"
      buttonLayout="horizontal"
      [allowEmpty]="false"
      [disabled]="isConfirmed"
      [(ngModel)]="currentTotal"
      (ngModelChange)="onChangeTotal()"
      [min]="0"
      spinnerMode="horizontal"
      incrementButtonIcon="fa-solid fa-plus"
      decrementButtonIcon="fa-solid fa-minus"
      class="w-full"
    ></p-inputNumber>
  </div>
</div>

<p-table
  [value]="deliveryWayByGroup"
  styleClass="p-datatable-striped"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="header">
    <tr>
      <th class="cursor-default">Tipo de dependência</th>
      <th class="cursor-default">
        {{ isDownload ? 'Pode fazer o download' : 'Limite por prefixo' }}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-prefixClassifications let-rowIndex="rowIndex">
    <tr>
      <td class="cursor-default">
        {{ prefixClassifications.detail.label }}
      </td>
      <td>
        <p-inputNumber
          *ngIf="!isDownload"
          inputId="print-batch-quantity"
          [showButtons]="true"
          buttonLayout="horizontal"
          [(ngModel)]="prefixClassifications.quantity"
          (ngModelChange)="onChangeData()"
          [disabled]="isConfirmed"
          [allowEmpty]="false"
          [min]="0"
          spinnerMode="horizontal"
          incrementButtonIcon="fa-solid fa-plus"
          decrementButtonIcon="fa-solid fa-minus"
          class="w-full"
        ></p-inputNumber>

        <p-inputSwitch
          *ngIf="isDownload"
          [ngModel]="prefixClassifications.checked"
          (onChange)="onToggle(rowIndex, $event)"
          [disabled]="isConfirmed"
        />
      </td>
    </tr>
  </ng-template>
</p-table>
